/** @file mirrorToTwin: copies the pose of some nodes onto their mirror twins (clip.mirrorPose). */
import type { EditorStore } from '../../state/editorTypes';
import { editTarget } from '../../panels/viewport/editTarget';

/** Dispatches `clip.mirrorPose`; tells the user when none of the nodes has a twin. */
export function mirrorToTwin(store: EditorStore, nodes: string[]): void {
  const s = store.getState();
  const doc = s.puppet.doc;
  if (!nodes.some((n) => doc?.puppet.nodes[n]?.mirror !== undefined)) { s.notify('info', 'The selected joints have no mirror twin.'); return; }
  const target = editTarget(s);
  if (target === null) return;
  void s.dispatch([{ name: 'clip.mirrorPose', input: { clip: target.clip.name, frame: target.frame, nodes } }], 'Mirror to twin');
}
